/**
 * The homepage: hero, bio, previews of Impact, Ventures and the Journal (each
 * only while its page is switched on in Settings), the convictions, and the
 * contact slab.
 */
import React from "react";
import { useLocales } from "../../core/i18n";
import { PageSEO } from "../../core/seo";
import { useSiteSettings } from "../../core/site";
import { CyclingWord, SweepWord } from "../../ui/motion";
import { ContactSlab, PageLayout } from "../../ui/shell";
import Convictions from "./Convictions";
import HomeAbout from "./HomeAbout";
import HomeHero from "./HomeHero";
import HomeImpact from "./HomeImpact";
import HomeJournal from "./HomeJournal";
import HomeVentures from "./HomeVentures";
import { HOME_JSON_LD } from "./homeJsonLd";

/** The "/" route. */
const HomePage = () => {
	const { t } = useLocales();
	const { pages } = useSiteSettings();
	const ctaWords = /** @type {string[]} */ (t("hero.ctaWords", { returnObjects: true }) || []);
	return (
		<PageLayout>
			<PageSEO
				title={t("homepage.pageTitle")}
				description={t("homepage.pageDescription")}
				twitterDescription={t("homepage.twitterDescription")}
				path="/"
				jsonLd={HOME_JSON_LD}
			/>
			<HomeHero />
			<HomeAbout />
			{pages.impact && <HomeImpact />}
			{pages.ventures && <HomeVentures />}
			<Convictions />
			{pages.journal && <HomeJournal />}
			<ContactSlab
				title={
					<>
						{t("hero.ctaTitle")} <SweepWord>{t("hero.ctaHighlight")}</SweepWord>,{" "}
						<CyclingWord words={ctaWords} />
					</>
				}
				description={t("hero.ctaDescription")}
			/>
		</PageLayout>
	);
};

export default HomePage;
